export default __webpack_public_path__ + "static/media/Education.9f834384.PNG";